import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'ecp-top-nav',
    templateUrl: './top-nav.component.html',
    styleUrls: ['./top-nav.component.css']
})
export class TopNavComponent implements OnInit {

    @Input() ecpTheme: 'default' | 'white' | 'green' = 'default';


    test(txt) {
        console.log(txt);
    }


    constructor() {
    }

    ngOnInit() {

    }

}
